import { render, staticRenderFns } from "./departmentEdit.vue?vue&type=template&id=a85724dc&scoped=true"
import script from "./departmentEdit.vue?vue&type=script&lang=js"
export * from "./departmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85724dc",
  null
  
)

export default component.exports